import BaseService from "./BaseService";

export default {
    index(filter) {
        var url = '/transactions?';

        if (filter.jurnal_from_date) {
            url += 'jurnal_from_date=' + filter.jurnal_from_date + '&';
        }

        if (filter.jurnal_to_date) {
            url += 'jurnal_to_date=' + filter.jurnal_to_date + '&';
        }

        if (filter.jurnal_accounts) {
            url += 'jurnal_accounts=' + filter.jurnal_accounts + '&';
        }

        return BaseService.get(url);
    },
    balances(filter) {
        var url = '/balances?';

        if (filter.accounts) {
            url += 'accounts=' + filter.accounts + '&';
        }

        if (filter.balance_from_date) {
            url += 'balance_from_date=' + filter.balance_from_date + '&';
        }

        if (filter.balance_to_date) {
            url += 'balance_to_date=' + filter.balance_to_date + '&';
        }

        return BaseService.get(url);
    },
    createTransaction(data) {
        return BaseService.post('/transactions', data);
    },
    updateTransaction(id, data) {
        return BaseService.put('/transactions/' + id, data);
    },
    deleteTransaction(id) {
        return BaseService.delete('/transactions/' + id);
    },
    getDashboardTransactions(id) {
        return BaseService.get('/transactions/dashboard/' + id);
    }
}